module.exports = __webpack_public_path__ + "img/Group794.b5cb7cc7.png";